(function(window, angular, undefined) {
    angular.module('formApp')
    .directive("scrollToError", ['scrollToPoint',function(scrollToPoint) {
        return {
            restrict: "A",
            link: function($scope, element) {
                $scope.checkNoneSubmitted = function(){
                 var firstInvalid = angular.element(element[0].querySelector('.ng-invalid'))[0];
                  firstInvalid.scrollIntoView();
                };
                
                element.on("submit", function(e){
                    e.preventDefault();
                    var firstInvalid = angular.element(element[0].querySelector('.ng-invalid'))[0];
                    if (firstInvalid) {
                        //firstInvalid.scrollIntoView()
                        if (firstInvalid.tagName.toLowerCase() === 'ng-form' || firstInvalid.hasAttribute('ng-form') || firstInvalid.hasAttribute('data-ng-form')) {
                            firstInvalid = angular.element(firstInvalid.querySelector("input.ng-invalid,select.ng-invalid,textarea.ng-invalid,div.ng-invalid, div#captcha"))[0];
                        }
                    }
                    if (firstInvalid) {
                        firstInvalid.scrollIntoView();
                        firstInvalid.focus();
                    }
                   
                });     
            }
        };
    }]);
})(window, window.angular);